module.exports = __webpack_public_path__ + "img/checkmark.c5c400f7.svg";